import _ from "lodash";
import {
  FINISH_DELETE_PROPOSAL,
  FINISH_FOLLOW_UNFOLLOW_COMPANY,
  LOADING_RESEARCH_INTEREST_FOLLOWS,
  LOAD_CURRENT_USER,
  LOAD_FUNDINGS,
  LOAD_PATENTS,
  LOAD_PUBLICATIONS,
  SET_CURRENT_USER,
  SET_FUNDINGS,
  SET_PATENTS,
  SET_PROPOSAL_EVAL,
  SET_PUBLICATIONS,
  SET_UNREAD_COUNT,
  START_DELETE_PROPOSAL,
  TOGGLE_LOGIN_MODAL,
  UPDATE_PROFILE_IMAGE,
  UPDATE_RESEARCH_INTEREST_FOLLOWS,
} from "../actions/profileActions";

const initialState = {
  currentUser: {
    id: null,
    profile_info: {},
    isLoggedIn: false,
  },
  loadingCurrentUser: false,
  loadingPatents: false,
  loadingPublications: false,
  loadingFundings: false,
  loginModalState: {
    isOpen: false,
    previousAction: null,
    initialView: null,
  },
  currentPatentId: null,
  currentPublicationId: null,
  currentFundingId: null,
  patents: [],
  publications: [],
  fundings: [],
  loadingResearchInterestFollows: false,
  unreadCount: 0,
  proposalEval: {},
};

const profileReducer = (state = initialState, action) => {
  let newObj;
  switch (action.type) {
    case SET_CURRENT_USER:
      return {
        ...state,
        currentUser: {
          ...action.payload,
          isLoggedIn: Boolean(action.payload.id),
        },
        loadingCurrentUser: false,
      };
    case LOAD_CURRENT_USER:
      return {
        ...state,
        loadingCurrentUser: true,
      };
    case SET_PUBLICATIONS:
      return {
        ...state,
        publications: action.payload,
        loadingPublications: false,
      };
    case LOAD_PUBLICATIONS:
      return {
        ...state,
        loadingPublications: true,
      };
    case SET_PATENTS:
      return {
        ...state,
        patents: action.payload,
        loadingPatents: false,
      };
    case LOAD_PATENTS:
      return {
        ...state,
        loadingPatents: true,
      };
    case SET_FUNDINGS:
      return {
        ...state,
        fundings: action.payload,
        loadingFundings: false,
      };
    case LOAD_FUNDINGS:
      return {
        ...state,
        loadingFundings: true,
      };
    case TOGGLE_LOGIN_MODAL:
      return {
        ...state,
        loginModalState: {
          isOpen: action.payload.open,
          previousAction: action.payload.previousAction,
          initialView: action.payload.initialView || null,
        },
      };
    case START_DELETE_PROPOSAL:
      return {
        ...state,
        deletingProposal: true,
      };
    case FINISH_DELETE_PROPOSAL:
      newObj = _.merge({}, state);
      if (action.payload && action.payload.proposalId) {
        newObj.currentUser.proposals = _.filter(
          newObj.currentUser.proposals,
          (p) => p.id !== action.payload.proposalId
        );
      }
      return {
        ...newObj,
        deletingProposal: false,
      };
    case FINISH_FOLLOW_UNFOLLOW_COMPANY:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profile_info: {
            ...state.currentUser.profile_info,
            followed_companies_info: action.payload.isFollowing
              ? [...state.currentUser.profile_info.followed_companies_info, action.payload.company]
              : state.currentUser.profile_info.followed_companies_info.filter(
                  (company) => company.id !== action.payload.company.id
                ),
          },
        },
      };
    case LOADING_RESEARCH_INTEREST_FOLLOWS:
      return {
        ...state,
        loadingResearchInterestFollows: action.payload,
      };
    case UPDATE_RESEARCH_INTEREST_FOLLOWS:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          profile_info: {
            ...state.currentUser.profile_info,
            followed_research_interests: action.payload,
          },
        },
        loadingResearchInterestFollows: false,
      };
    case SET_UNREAD_COUNT:
      return {
        ...state,
        unreadCount: action.payload,
      };
    case SET_PROPOSAL_EVAL:
      return {
        ...state,
        proposalEval: action.payload,
      };
    case UPDATE_PROFILE_IMAGE:
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          image: action.payload,
        },
      };
    default:
      return state;
  }
};
export default profileReducer;
